import { composeReducers } from 'common/util';
import lodash from 'lodash';

import {
    LOAD_STUDY_DELEGATIONS,
    ADD_STUDY_DELEGATION,
    UPDATE_STUDY_DELEGATION,
    DELETE_STUDY_DELEGATION,
    UNLOAD_STUDY_TASKS_AND_DELEGATIONS
} from 'pages/delegationOfAuthority/actions/studyDelegations';

const KEYS_TO_FILTER_ON_UNLOAD = ['doaStudyTasks', 'doaStudyDelegations', 'users', 'doaTestaments'];

export function loadStudyDelegations(state, action) {
    if (action && action.type === 'LOADING_DELEGATIONS') {
        return {
            ...state,
            app: {
                ...state.app,
                loadingStudyDelegations: true,
                loadingStudySignatures: true,
            }
        };
    }
    if (!action || action.type !== LOAD_STUDY_DELEGATIONS) {
        return state;
    }
    const studyDelegations = action.payload;

    return {
        ...state,
        doaStudyDelegations: studyDelegations,
        app: {
            ...state.app,
            loadingStudyDelegations: false,
        }
    };
}

export function addStudyDelegation(state, action) {
    if (action && action.type === 'UPSERT_DELEGATION_BEGIN') {
        return {
            ...state,
            app: {
                ...state.app,
                upsertDelegationRequesting: true,
            }
        };
    }

    if (action && action.type === 'UPSERT_DELEGATION_END') {
        return {
            ...state,
            app: {
                ...state.app,
                upsertDelegationRequesting: false,
            }
        };
    }

    if (!action || action.type !== ADD_STUDY_DELEGATION) {
        return state;
    }

    const newStudyDelegation = action.payload;
    if (lodash.isNil(newStudyDelegation) || lodash.isEmpty(newStudyDelegation)) {
        return state;
    }

    const { doaStudyDelegations } = state;
    const updatedUserDelegations = doaStudyDelegations.concat(newStudyDelegation);

    return {
        ...state,
        doaStudyDelegations: updatedUserDelegations,
    };
}

export function updateStudyDelegation(state, action) {
    if (!action || action.type !== UPDATE_STUDY_DELEGATION) {
        return state;
    }

    let updatedDelegation = action.payload;
    if (lodash.isNil(updatedDelegation)) {
        return state;
    }

    const updatedDelegations = state.doaStudyDelegations;
    const outdatedDelegationIndex = updatedDelegations.findIndex(delegation => delegation.id === updatedDelegation.id);
    const outdatedDelegation = state.doaStudyDelegations[outdatedDelegationIndex];

    if (outdatedDelegation.signatures) {
        updatedDelegation.signatures = outdatedDelegation.signatures;
    }

    updatedDelegations[outdatedDelegationIndex] = updatedDelegation;

    return {
        ...state,
        doaStudyDelegations: updatedDelegations,
    };
}

export function deleteStudyDelegation(state, action) {
    if (!action || action.type !== DELETE_STUDY_DELEGATION) {
        return state;
    }

    const deletedDelegation = action.payload;
    const currentDelegations = state.doaStudyDelegations;
    if (lodash.isNil(deletedDelegation)) {
        return state;
    }

    const updatedDelegations = currentDelegations.filter(delegation => delegation.id !== deletedDelegation.id);
    return {
        ...state,
        doaStudyDelegations: updatedDelegations,
    };
}

export function unloadStudyTasksAndDelegations(state, action) {
    if (!action || action.type !== UNLOAD_STUDY_TASKS_AND_DELEGATIONS) {
        return state;
    }

    return lodash.pickBy(state, (value, key) => !KEYS_TO_FILTER_ON_UNLOAD.includes(key));
}

export default composeReducers(
    loadStudyDelegations,
    addStudyDelegation,
    updateStudyDelegation,
    deleteStudyDelegation,
    unloadStudyTasksAndDelegations,
);